<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{
            user.full_name
              ? user.full_name
              : user.first_name + " " + user.last_name
          }}
        </p>
        <small>{{ user.username }}</small>
      </div>
      <b-avatar
        size="40"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon icon="UserIcon" size="22" />
      </b-avatar>
    </template>
    <b-dropdown-item
      :to="
        isMinistryUser ? { name: 'ministry-user-profile' } : { name: 'profile' }
      "
      link-class="d-flex align-items-center"
      v-can="{
        slug: isMinistryUser ? 'ministry_profile' : 'personal-profile',
        action: 'S',
      }"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>الملف الشخصي</span>
    </b-dropdown-item>

    <!-- <b-dropdown-item
      :to="{ name: 'apps-email' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="MailIcon" class="mr-50" />
      <span>المراسلات</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'apps-todo' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
      <span>المهام</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'apps-chat' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
      <span>التواصل السريع</span>
    </b-dropdown-item> -->

    <b-dropdown-item
      v-can="{ slug: 'ngo_faqs', action: 'S' }"
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="HelpCircleIcon" class="mr-50" />
      <span>الأسئلة الأكثر شيوعاً</span>
    </b-dropdown-item>
    <b-dropdown-divider />

    <b-dropdown-item link-class="d-flex align-items-center" @click="onLogout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>تسجيل خروج</span>
    </b-dropdown-item></b-nav-item-dropdown
  >
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
// import { initialAbility } from "@/libs/acl/config";
// import useJwt from "@/auth/jwt/useJwt";
import { avatarText } from "@core/utils/filter";
import { mapGetters, mapActions } from "vuex";
import user from "@/store/user";
import AuthHelpers from "@/utils/auth-helpers";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      avatarText,
      isMinistryUser: AuthHelpers.isUserMinistry(),
    };
  },
  computed: {
    ...mapGetters("User", ["user"]),
  },
  methods: {
    ...mapActions("Auth", ["logout", "tempLogout", "ministryLogout"]),
    async onLogout() {
      if (AuthHelpers.isUserMinistry()) {
        await this.ministryLogout();
        this.$router.push({ name: "ministry-login" });
      } else if (AuthHelpers.isUserTemp()) {
        await this.tempLogout();
        this.$router.push({ name: "auth-login" });
      } else {
        await this.logout();
        this.$router.push({ name: "auth-login" });
      }
    },
  },
};
</script>
